import * as React from 'react'
import { observer } from 'mobx-react'
import { useBrandingSettings } from 'hooks/branding'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from 'components/ModalSheet'
import Button from 'components/Button'
import styles from './UnarchiveBundleModal.sass'
import UnarchiveBundleViewModel from './UnarchiveBundleViewModel'

interface Props {
  vm: UnarchiveBundleViewModel
}

export default observer(function UnarchiveBundleDialog({ vm }: Props) {
  const { corporateMode } = useBrandingSettings()
  const bundleName = vm.bundle.name
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_archive.svg')}
              alt="Unarchive bundle"
            />
          )}
          <h3 className={styles.title}>You’re about to unarchive a bundle</h3>
          <p className={styles.description}>
            Are you sure you want to unarchive the{' '}
            <span className={styles.bundleName}>{bundleName}</span> bundle? All
            jobs will be able to reference this bundle again.
          </p>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            disabled={vm.unarchive.pending}
            onClick={vm.close}
            type="default"
            dataTest="bundle-close-unarchive-modal"
          >
            Cancel
          </Button>
          <Button
            onClick={vm.unarchive}
            loading={vm.unarchive.pending}
            disabled={vm.unarchive.pending}
            type="primary"
            dataTest="bundle-modal-unarchive-button"
          >
            Unarchive
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
